import { makeStyles } from 'tss-react/mui';

import theme from '@/theme';

const useCloudSourcesTableCellRenderersStyles = makeStyles()(() => ({
  deviceStatusIconStyle: {
    display: 'flex',
    marginRight: '0.5rem'
  },
  icoLabelStyle: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  routeButtonTooltip: {
    backgroundColor: theme.vars.palette.background.navigation,
    fontSize: '0.875rem',
    maxWidth: 'none'
  },
  routeButtonTooltipArrow: {
    color: theme.vars.palette.background.navigation
  },
  ellipsisMenu: {
    '& ul': {
      backgroundColor: theme.vars.palette.background.elevation1
    },
    '& li:hover': {
      backgroundColor: theme.vars.palette.background.elevation0
    }
  }
}));

export default useCloudSourcesTableCellRenderersStyles;
